<template>
  <div class="icelinktest-container">
    <div class="action">
      <v-text-field
        class="action__input"
        v-model="sessionId"
        label="Session ID" />

      <v-btn @click="onStartButtonClick" color="ml-2 info">start</v-btn>
      <v-btn @click="onStopButtonClick" color="ml-2 info">stop</v-btn>
    </div>
    <div class="action">
      <v-text-field
        class="action__input"
        v-model="p2pData"
        label="Data" />
      <v-btn @click="onSendDataButtonClick" color="ml-2 info">Send Data</v-btn>
    </div>
    <div ref="videoElm" class="video-container"></div>
  </div>
</template>

<script>
import {sessionAppService, SessionApplicationServiceErrorName, Creator, Attendee} from 'langyan';
// import {Attendee, SessionTicket} from 'langyan';
import {mapState} from 'vuex';
// import {Subject} from 'rxjs';

export default {
  data() {
    return {
      sessionId: null,
      p2pData: null
    };
  },

  computed: {
    ...mapState({
      username: state => state.profile.username,
      userid: state => state.userid
    })
  },

  async mounted() {
    // window.fm.icelink.webrtc.setChromeExtension({
    //   extensionId: 'nidjnlpklmpflfmfflalpddmadlgjckn'
    // });

    // const fm = window.fm;
    // this.logProvider = new fm.textLogProvider(fm.logLevel.Debug);
    // const logProvider = new fm.domLogProvider(new fm.domLogProvider(this.$refs.logElm, fm.logLevel.Debug));
    // fm.log.setProvider(this.logProvider);

    await sessionAppService.errorOccurred.addListener(SessionApplicationServiceErrorName, error => {
      log.tag('session').error(error);
    });
  },

  methods: {
    async onStartButtonClick() {
      if (!this.sessionId) {
        const creator = Creator.from(this.userid, this.username);
        const lukeAttendee = Attendee.from('5955d9102963a7a00835f7f1', 'luke');
        this.st = sessionAppService.requestToStartVideoAudioSessionWith(creator, false, [lukeAttendee]);
        // this.st = sessionAppService.requestToStartAudioSessionWith(creator, false, [lukeAttendee]);
        // this.st = sessionAppService.requestToStartShareScreenSessionWith(creator, false, [lukeAttendee]);
        // this.st = sessionAppService.requestToStartDataSessionWith(creator, [lukeAttendee]);

        log.tag('session').info(this.st.id);

        // start multimedia session
        await sessionAppService.startSessionAsync(creator.toAttendee(), this.st.id, this.$refs.videoElm);

        // start data session
        // this.localDataProvider = new Subject();
        // this.remoteDataReceiver = new Subject();
        // this.remoteDataReceiver.subscribe({
        //   next: (v) => {
        //     this.p2pData = v;
        //   }
        // });
        // await sessionAppService.startDataSessionAsync(creator.toAttendee(), this.st.id, this.localDataProvider, this.remoteDataReceiver);

        const sessionDto = await sessionAppService.querySessionAsync(this.st.id);
        log.tag('session').info(sessionDto);
        this.sessionId = sessionDto.id;
      } else {
        log.tag('session').info('Join session: ' + this.sessionId);
        const attendee = Attendee.from(this.userid, this.username);
        // join multimedia session
        await sessionAppService.joinSessionAsync(attendee, this.sessionId, this.$refs.videoElm);

        // join data session
        // this.localDataProvider = new Subject();
        // this.remoteDataReceiver = new Subject();
        // this.remoteDataReceiver.subscribe({
        //   next: (v) => {
        //     this.p2pData = v;
        //   }
        // });
        // await sessionAppService.joinDataSessionAsync(attendee, this.sessionId, this.localDataProvider, this.remoteDataReceiver);

        log.tag('session').info('Join session succeeded.');
      }

      // console.log(this.sessionId);
      // console.log(this.$refs.videoElm);
    },

    async onStopButtonClick() {
      const sessionId = this.st ? this.st.id : this.sessionId;
      this.sessionId = null;
      if (!sessionId) {
        log.tag('session').info('No session id');
        return;
      }

      const sessionDto = await sessionAppService.querySessionAsync(sessionId);
      log.tag('session').info(sessionDto);
      const attendee = Attendee.from(this.userid, this.username);
      await sessionAppService.stopSessionAsync(attendee, sessionDto.id);
    },

    onSendDataButtonClick() {
      if (!this.localDataProvider) return;
      if (!this.p2pData) return;
      this.localDataProvider.next(this.p2pData);
    }
  }
};
</script>

<style lang="stylus" scoped>
.icelinktest-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.action {
  display: flex;
  align-items: center;
  padding: 1rem;
}

.action__input {
  margin-top: 1rem;
  width: 300px;
  flex: none;
}

.video-container {
  // flex-grow: 1;
  width: 100%;
  height: 50%;
  box-shadow: 1px 1px 5px -1px rgba(0, 0, 0, 0.3) inset, 0 0 10px rgba(0, 0, 0, 0.1) inset;
}
</style>
